import { Component, Input, ViewEncapsulation } from '@angular/core';
import { GoogleData } from '../../services/GoogleData/GoogleData'
import { Book } from '../../services/GoogleData/Book'
import { NgbModal, NgbActiveModal } from '@mattlewis92/ng-bootstrap';

@Component({
    selector: 'import-finder',
    templateUrl: './import-finder.html',
    encapsulation: ViewEncapsulation.None
})
export class ImportFinderComponent {
    @Input() bookData:any;

    selectedId:string;
    selectedBook:Promise<void | Book>;

    selectBook(googleId) {
        this.selectedId = googleId;
        this.selectedBook = this.googleData.getBook(googleId).catch(console.error);
    };

    constructor(private googleData:GoogleData, public activeModal: NgbActiveModal) { }
}




// WEBPACK FOOTER //
// ./web/static/components/import-finder/import-finder.ts